export default __webpack_public_path__ + "static/media/VD2.28e28297.png";